import http from '@core/fetch'

interface IGetMemberListProps {
  name?: string,
  orderPageListAll?: boolean // 不分页查所有
  page?: number
  perPage?: number
  status?: 0 | 1 | 2 // 审核状态 0 待审核 1通过 2未通过   不传则所有状态
}

export default {
  getMemberList: (data: IGetMemberListProps) => http.get('/hms/merchant/adminApi/emceeMember/page', { body: data}),
  saveMemberOrder: (ids: number[]) => http.post('/hms/merchant/adminApi/emceeMember/order', { body: {ids}}),
  removeMember: (id: string) => http.post('/hms/merchant/adminApi/emceeMember/remove', { body: {id}}),
}
